<template>
    <TableDocument :posts="posts" :translate="translate" />
</template>

<script setup>
  import { useTranslationStore } from '@/stores/translations'
  const translationStore = useTranslationStore()
  const translate = translationStore.translate


defineProps({
  posts: {
    type: Object,
    required: true,
  },
});

// Dynamically import the Download component
const TableDocument = defineAsyncComponent(() =>
  import(`@/components/apps/table/Document.vue`)
);
</script>
